<template>
    <div ref="modal-wrapper" style="display: none"></div>
</template>

<script>
    export default {
        props: {
            to: {
                type: String,
                required: true,
            }
        },
        created() {
            window.portalModalInstance = new Vue()
        },
        mounted() {
            this.$nextTick(this.setup)
        },
        updated() {
            this.sendUpdate()
        },
        methods: {
            sendUpdate() {
                window.portalModalInstance.$emit(`update:${this.to}`, this.$slots.default)
            },
            setup() {
                this.$nextTick(this.sendUpdate)
            },
        }
    }
</script>
